"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currency = void 0;
/**
 * Input a float or int in the form of a string or number and format to currency
 * @param data - number or string to be converted into currency
 * @returns data with '$' prepended and two decimal places
 */
function currency(data) {
    if (typeof data === 'string') {
        data = parseFloat(data);
    }
    data = data.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    data = '$' + data;
    return data;
}
exports.currency = currency;
